<template>
  <div>
    <CRow>
      <CCol xs="12" lg="12">
        <CCard>
          <CCardHeader>
            <div class="row">
              <CCol sm="6" class="align-self-center">
                <strong>{{ $lang.collegeMember.crud.view }}</strong>
              </CCol>
            </div>
          </CCardHeader>
          <CCardBody>
            <div class="detail-div">
              <CRow>
                <CCol md="3">
                  <CRow>
                    <CCol md="12" class="text-left">
                      <img alt="Profile Pic" :src="imageURL" height="auto" width="100%"/>
                    </CCol>
                  </CRow>
                </CCol>
                <CCol md="9" class="align-self-center">
                  <CRow>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">{{ $lang.collegeMember.form.firstName }}</p>
                      <p class="custome-detail">{{ collegeMember.firstName }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">{{ $lang.collegeMember.form.name }}</p>
                      <p class="custome-detail">{{ collegeMember.name }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">{{ $lang.collegeMember.form.role }}</p>
                      <p class="custome-detail">{{ collegeMember.role }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">{{ $lang.collegeMember.form.email }}</p>
                      <p class="custome-detail">{{ collegeMember.email }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">{{ $lang.collegeMember.form.mobile_number }}</p>
                      <p class="custome-detail">{{ collegeMember.countryCode }} {{collegeMember.username }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">{{ $lang.collegeMember.form.cityName }}</p>
                      <p class="custome-detail">{{ collegeMember.cityName }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">{{ $lang.collegeMember.form.stateName }}</p>
                      <p class="custome-detail">{{ collegeMember.stateName }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">{{ $lang.collegeMember.form.countryName }}</p>
                      <p class="custome-detail">{{ collegeMember.countryName }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">{{ $lang.collegeMember.form.department }}</p>
                      <p class="custome-detail">{{ collegeMember.department }}</p>
                    </CCol>
                    <CCol sm="6" md="4" lg="4">
                      <p class="custome-labal">{{ $lang.collegeMember.form.isAdmin }}</p>
                      <p class="custome-detail" v-if="collegeMember.isAdmin == 0">No</p>
                      <p class="custome-detail" v-if="collegeMember.isAdmin == 1">Yes</p>
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import Vue from "vue";
import store from "/src/store/store.js";
import {staff} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import {serverBus} from "../../main";
Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
export default {
  name: "CollegeMembers",
  mixins: [Mixin],
  data() {
    return {
      imageURL: "",
      imageRemove: "",
      FILE: null,
      existImage: false,
      imageOutput: "",
      saving: false,
      saved: false,
      adminId: "",
      err_msg: "",
      largeModal: false,
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      self: this,
      msg: "",
      items: [],
      activePage: 1,
      module: staff,
      avatar: {
        imageURl: "",
      },
      collegeMember: {
        imageURL: "",
        cityName: "",
        countryCode: "",
        countryName: "",
        department: "",
        email: "",
        firstName: "",
        isAdmin: "",
        name: "",
        role: "",
        stateName: "",
        username: "",
      },
    };
  },
  mounted() {
    let self = this;
    self.dismissCountDown = 0;
    localStorage.setItem("showAlert", "");
    self.dismissCountDown = 0;
    const id = this.$route.params.id;
    self.dismissCountDown = 0;
    self.editId = id;
    axios
        .get('college/member/'+self.editId)
        .then((response) => {
          const responseData = response.data.data;
          self.collegeMember.cityName = responseData.cityName;
          self.collegeMember.countryCode = responseData.countryCode;
          self.collegeMember.countryName = responseData.countryName;
          self.collegeMember.department = responseData.department;
          self.collegeMember.email = responseData.email;
          self.collegeMember.firstName = responseData.firstName;
          self.collegeMember.isAdmin = responseData.isAdmin;
          self.collegeMember.name = responseData.name;
          self.collegeMember.role = responseData.role;
          self.collegeMember.stateName = responseData.stateName;
          self.collegeMember.username = responseData.username;
          self.imageURL = responseData.avatar;
          if (responseData.imageUrl !== "") {
            serverBus.$emit("send_cropper_image_url", responseData.avatar);
            self.existImage = true;
          }
          store.commit("showLoader", false); // Loader Off
        })
        .catch(function (error) {
          store.commit("showLoader", false); // Loader Off
        });
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
    avatar: {
      handler: function () {
        this.saved = false;
      },
      deep: true,
    },
  },
  methods: {},
};
</script>
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
